/* V2 子菜单动画控制 - 每次打开都重新播放 */
document.addEventListener('DOMContentLoaded', function() {
  // 监听子菜单的打开/关闭 - 保持不变
  const menuDrawer = document.querySelector('.menu-drawer');
  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', function(event) {
      // 检查是否是子菜单的 details 元素
      if (event.target.matches('.menu-drawer__menu details')) {
        const submenu = event.target.querySelector('.menu-drawer__submenu');
        if (!submenu) return;
        
        if (event.target.open) {
          // 子菜单打开时
          const menuItems = submenu.querySelectorAll('.menu-drawer__menu > li');
          
          // 先移除动画类，强制重置
          menuItems.forEach(item => {
            item.style.animation = 'none';
          });
          
          // 强制浏览器重绘
          void submenu.offsetHeight;
          
          // 重新添加动画
          menuItems.forEach((item, index) => {
            item.style.animation = `slideFromRight 0.5s ease ${index * 0.1 + 0.1}s both`;
          });
        } else {
          // 子菜单关闭时，清理动画
          const menuItems = submenu.querySelectorAll('.menu-drawer__menu > li');
          menuItems.forEach(item => {
            item.style.animation = '';
          });
        }
      }
    }, true); // 使用捕获阶段
  }
});